import React, { useRef, useState } from "react";

export default function BeforeAfterSlider() {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    const p = ((clientX - r.left) / r.width) * 100;
    setPos(Math.max(2, Math.min(98, p)));
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div
        ref={ref}
        data-testid="before-after-slider"
        className="relative h-80 sm:h-96 rounded-2xl overflow-hidden select-none glass-strong cursor-ew-resize"
        onMouseMove={(e) => dragging.current && move(e.clientX)}
        onMouseDown={(e) => { dragging.current = true; move(e.clientX); }}
        onMouseUp={() => (dragging.current = false)}
        onMouseLeave={() => (dragging.current = false)}
        onTouchMove={(e) => move(e.touches[0].clientX)}
      >
        {/* AFTER (premium) full */}
        <div className="absolute inset-0 bg-gradient-to-br from-[#0B0F19] to-[#1a1033]">
          <div className="absolute inset-0 nova-grid opacity-40" />
          <div className="p-8 h-full flex flex-col justify-between">
            <div className="flex items-center justify-between">
              <div className="font-display font-bold text-white text-xl">Aurelia <span className="text-violet-400">Jewels</span></div>
              <div className="flex gap-2">{["Home","Shop","Visit"].map((t)=>(<span key={t} className="text-xs text-slate-300 bg-white/5 px-2.5 py-1 rounded-md">{t}</span>))}</div>
            </div>
            <div className="max-w-sm">
              <div className="h-3 w-40 rounded bg-white/25 mb-3" />
              <div className="h-2 w-56 rounded bg-white/15 mb-2" />
              <div className="h-2 w-44 rounded bg-white/10 mb-5" />
              <span className="inline-block bg-violet-600 text-white text-sm font-semibold px-4 py-2 rounded-lg btn-glow">Book a Viewing</span>
            </div>
            <span className="self-end text-[11px] font-semibold text-emerald-300 bg-emerald-500/15 px-2.5 py-1 rounded-full">AFTER — Nova premium</span>
          </div>
        </div>

        {/* BEFORE (dated) clipped */}
        <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
          <div className="absolute inset-0 bg-[#d8d4c8]" style={{ width: `${10000 / pos}%` }}>
            <div className="p-6 h-full flex flex-col justify-between text-[#333] font-serif">
              <div className="flex items-center justify-between border-b-2 border-[#999] pb-2">
                <div className="font-bold text-lg underline">AURELIA JEWELLERY SHOP</div>
                <div className="text-[10px]">Visitors: 001245</div>
              </div>
              <div>
                <div className="text-sm mb-1">★ Welcome to our website ★</div>
                <div className="h-2 w-48 bg-[#b5b0a0] mb-1.5" />
                <div className="h-2 w-40 bg-[#b5b0a0] mb-3" />
                <span className="inline-block bg-[#1a4fa0] text-white text-xs px-3 py-1.5 border-2 border-[#0a2a60]">Click Here!!!</span>
              </div>
              <span className="self-start text-[11px] font-bold text-[#7a2020] bg-[#e5c9c9] px-2 py-1">BEFORE — outdated</span>
            </div>
          </div>
        </div>

        {/* handle */}
        <div className="absolute top-0 bottom-0 w-0.5 bg-white/80" style={{ left: `${pos}%` }}>
          <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-9 h-9 rounded-full bg-white grid place-items-center shadow-lg text-[#0B0F19] font-bold">⇄</div>
        </div>
      </div>
      <p className="text-center text-xs text-slate-500 mt-3">Illustrative concept. Drag to compare an outdated layout with a premium Nova layout.</p>
    </div>
  );
}
